import { QueryKey } from "common/enums/query-key";
import { UndefinedInitialDataOptions, useQuery } from "@tanstack/react-query";
import { getConnectedAccount } from "services/api/connected-account-api.service";
import { ConnectedAccountDto } from "common/types/services/api/payment/connected-account-dto.type";

export default function useGetConnectedAccount(options?: Omit<UndefinedInitialDataOptions<ConnectedAccountDto, Error, ConnectedAccountDto, QueryKey[]>, 'queryFn' | 'queryKey'>) {
  return useQuery({
    queryKey: [QueryKey.ConnectedAccount],
    queryFn: () => getConnectedAccount(),
    ...options
  });
}